import React from "react";
import logo from "../resources/logos/logo_white.png";
import logoAniversary from "../resources/logos/logo-anniversary.png";

import styled from "styled-components";

export const Logo = ({ width }) => <StyledLogo width={width}></StyledLogo>;

const StyledLogo = styled.img.attrs({
	src: logoAniversary,
})`
	width: ${(props) => props.width};
	height: auto;
`;
